import { useLogout } from '@btime/react-session'
import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Link from '../../components/actions/Link'
import Logo from '../../components/shapes/Logo'
import Separator from '../../packages/kiti/components/helpers/Separator'
import Text from '../../packages/kiti/components/presentation/Text'

const HeaderBar = () => {
  const logout = useLogout()

  return (
    <Separator bgColor="menu" weight={4} usePadding>
      <Grid align="center" justify="space-between" gutter={0.3}>
        <Logo white width="4.5rem" />

        <Col flex={1} />

        <Link onClick={() => logout()}>
          <Grid align="center" justify="space-between" gutter={0.3}>
            <Text color="white" bold size="xsmall">
              Deslogar
            </Text>

            <Icon name="RiLogoutBoxRLine" color="white" size={1.2} />
          </Grid>
        </Link>
      </Grid>
    </Separator>
  )
}

export default HeaderBar
